import React from "react";

import login from "assets/images/login.png";
import login2 from "assets/images/login2.png";
import login3 from "assets/images/login3.png";
import LoginForm from "./form";
import CustomCarousel from "components/common/Carousel";
import AppLogo from "components/common/Logo";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";

const Login = () => {
	const mdScreen = useMediaQuery("(min-width:767px)");
	const carouselItems = [
		{
			img: login, // Replace with actual image URLs
			quote: "Fashion is the armour to survive the reality of everyday life.",
			author: "Bill Cunningham",
		},
		{
			img: login2,
			quote: "Style is a way to say who you are without having to speak.",
			author: "Rachel Zoe",
		},
		{
			img: login3,
			quote: "Fashion is what you buy. Style is what you do with it.",
			author: "Unknown",
		},
	];

	return (
		<div className="flex items-center justify-center bg-gray-100">
			<div className="flex flex-col md:flex-row min-h-screen w-full bg-white relative">
				<Link
					to={"/"}
					className="flex md:absolute justify-center md:top-2 md:left-4 md:ml-8 z-50 mt-2 cursor-pointer"
				>
					<AppLogo mode={mdScreen ? "light" : "dark"} />
				</Link>
				<div className="md:w-1/2 flex justify-center items-center bg-orange-100 m-5 md:m-0">
					<CustomCarousel autoPlay={true} interval={10000} infiniteLoop={true}>
						{carouselItems.map((item, i) => (
							<CarouselItem key={i} item={item} />
						))}
					</CustomCarousel>
				</div>

				<LoginForm />
			</div>
		</div>
	);
};

// CarouselItem Component
const CarouselItem = ({ item }: any) => {
	return (
		<Box className="flex flex-col justify-center items-center relative h-full max-h-[60vh] md:h-screen md:max-h-screen">
			<img src={item.img} alt="Fashion Quote" className="h-full object-fill" />
			<Box className="absolute w-5/6 bottom-[40px] md:bottom-[100px]">
				<Typography className="text-base md:text-xl text-white mb-2 text-left font-semibold">
					"{item.quote}"
				</Typography>
				<Typography className="text-base md:text-xl text-white text-right font-semibold">
					- {item.author}
				</Typography>
			</Box>
		</Box>
	);
};

export default Login;
